module.exports = __webpack_public_path__ + "b05ba8ead8917f53dc640a63fa3c1810.png";